// src/services/storage/LocalStorageAdapter.ts
import type { StorageAdapter } from './types';

class MemoryAdapter implements StorageAdapter {
  private map = new Map<string, string>();
  getItem(k: string) {
    return this.map.get(k) ?? null;
  }
  setItem(k: string, v: string) {
    this.map.set(k, v);
  }
  removeItem(k: string) {
    this.map.delete(k);
  }
  clear() {
    this.map.clear();
  }
}

export class LocalStorageAdapter implements StorageAdapter {
  private target: StorageAdapter;

  constructor() {
    if (typeof window === 'undefined' || !('localStorage' in window)) {
      this.target = new MemoryAdapter();
    } else {
      try {
        const test = '__test__';
        window.localStorage.setItem(test, '1');
        window.localStorage.removeItem(test);
        // Structural typing: window.localStorage matches StorageAdapter
        this.target = window.localStorage as unknown as StorageAdapter;
      } catch {
        this.target = new MemoryAdapter();
      }
    }
  }

  getItem(k: string) {
    return this.target.getItem(k);
  }
  setItem(k: string, v: string) {
    this.target.setItem(k, v);
  }
  removeItem(k: string) {
    this.target.removeItem(k);
  }
  clear() {
    this.target.clear?.();
  }
}
